import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectBox } from "@vertesia/ui/core";
import { useEffect, useState } from "react";
import { useTypeRegistry } from "./TypeRegistryProvider.js";
import { useUITranslation } from '../../../i18n/index.js';
export function SelectContentType({ className, defaultValue, onChange, isClearable, multiple }) {
    const { t } = useUITranslation();
    const { registry: typeRegistry } = useTypeRegistry();
    const [isMounted, setIsMounted] = useState(false);
    const optionLabel = (type) => {
        if (type === null)
            return t('store.none');
        return (_jsxs("div", { children: [_jsx("div", { className: "text-sm", children: type.name }), _jsx("div", { className: "text-xs text-muted truncate", children: type.description })] }));
    };
    const [selectedType, setSelectedType] = useState();
    const [selectedTypes, setSelectedTypes] = useState([]);
    useEffect(() => {
        if (!isMounted) {
            setIsMounted(true);
            if (typeRegistry && defaultValue) {
                if (multiple && Array.isArray(defaultValue)) {
                    const types = typeRegistry.types.filter(t => defaultValue.includes(t.id));
                    setSelectedTypes(types);
                }
                const type = typeRegistry.types.find(t => t.id === defaultValue);
                if (type) {
                    setSelectedType(type);
                }
            }
        }
    }, [typeRegistry, defaultValue, multiple]);
    const _onChange = (option) => {
        setSelectedType(option || undefined);
        onChange(option);
    };
    const _onChangeMultiple = (options) => {
        setSelectedTypes(options);
        onChange(options);
    };
    if (multiple) {
        return (_jsx("div", { className: 'flex flex-col gap-4 content-between', children: _jsx(SelectBox, { options: typeRegistry?.types || [], value: selectedTypes, onChange: _onChangeMultiple, placeholder: t('store.chooseContentTypes'), optionLabel: optionLabel, className: className || "text-sm bg-background", filterBy: "name", isClearable: isClearable || false, multiple: true }) }));
    }
    return (_jsx("div", { className: 'flex flex-col gap-4 content-between', children: _jsx(SelectBox, { options: typeRegistry?.types || [], value: selectedType, onChange: _onChange, placeholder: t('store.chooseContentType'), optionLabel: optionLabel, className: className || "text-sm bg-background", filterBy: "name", isClearable: isClearable || false }) }));
}
//# sourceMappingURL=SelectContentType.js.map